import { useRecoilValue } from "recoil";
import { Restaurant } from "../../../../api/types";
import { geoCoordState } from "../../../../recoil/geo";
import { getDistanceKm } from "../../../../utils/common";
import {
  PubRestaurantItemWrapper,
  PubRestaurantListWrapper,
  PubRestaurantWrapper,
} from "./styles/restaurant.style";
import { useState } from "react";
import RestaurantMore from "./RestaurantMore";

export interface RestaurantProps {
  data: Restaurant[];
  boxRef: any;
}

const PubRestaurant = ({ data, boxRef }: RestaurantProps) => {
  const { latitude, longitude } = useRecoilValue(geoCoordState);
  const [openMore, setOpenMore] = useState(false);
  const [item, setItem] = useState<Restaurant | null>(null);
  return (
    <PubRestaurantWrapper ref={boxRef}>
      <div className="title">주변 맛집</div>
      <PubRestaurantListWrapper>
        {data.map((item, index) => (
          <PubRestaurantItemWrapper
            key={index}
            onClick={() => {
              setItem(item);
              setOpenMore(!openMore);
            }}
          >
            <img src={item.imageUrl} alt={item.restaurantName} />
            <div className="title">{item.restaurantName}</div>
            <div className="menu">
              대표메뉴: {item.menu}{" "}
              <span>{Number(item.menuPrice).toLocaleString()}원</span>
            </div>
            <div className="location">
              <img
                alt="icon"
                className="icon"
                src="/image-web/Icon/Map%20pin/small.svg"
              />
              <span className="text">
                {getDistanceKm(latitude, longitude, item.lat, item.lon)} km
              </span>
            </div>
          </PubRestaurantItemWrapper>
        ))}
      </PubRestaurantListWrapper>
      {openMore && (
        <RestaurantMore
          data={item}
          setShowMoreOption={setOpenMore}
          setSelectedStore={setItem}
        />
      )}
    </PubRestaurantWrapper>
  );
};

export default PubRestaurant;
